import React, {
  useEffect,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  useSelector,
  useDispatch,
} from "react-redux";

import {
  useLocation,
} from "react-router-dom";

import {
  motion,
  AnimatePresence,
} from "framer-motion";

import {
  Loader,
  MealsCard,
  Pagination,
} from "../components/utils";

import {
  Fotter,
  Header,
} from "../components/layout";

import {
  getAllMeals,
} from "../redux/actions/meals";

import {
  useStateContext,
} from "../context/ContextProvider";

import {
  media,
} from "../server";

import {
  FiArrowDown,
  FiSliders,
} from "react-icons/fi";

import {
  BiRestaurant,
} from "react-icons/bi";


function AllMeals() {
  const {
    t,
  } = useTranslation();

  const dispatch =
    useDispatch();

  const {
    currentDir,
  } = useStateContext();

  const isRTL =
    currentDir === "rtl";

  const location =
    useLocation();

  const {
    category,
  } = location.state || {};

  const categoryId =
    category?._id;


  /* =====================================
      REDUX
  ====================================== */

  const {
    isLoading,
    Allmeals,
    pagination,
  } = useSelector(
    (state) =>
      state.Meals
  );


  /*
   * طريقة عرض الوجبات على الهاتف.
   *
   * one = عمود واحد
   * two = عمودان
   *
   * الافتراضي عمودان.
   */

  const mobileMealColumns =
    useSelector(
      (state) =>
        state.Layout
          ?.mobileMealColumns ||
        "two"
    );


  /* =====================================
      MOBILE DETECTION
  ====================================== */

  /*
   * مهم:
   * compact يجب أن يطبق على الهاتف فقط.
   *
   * لو كانت قيمة Redux = two
   * ونحن على الكمبيوتر،
   * لا نريد أن يؤثر ذلك على شكل MealsCard.
   */

  const [
    isMobile,
    setIsMobile,
  ] = useState(() => {
    if (
      typeof window ===
      "undefined"
    ) {
      return false;
    }

    return (
      window.innerWidth <
      768
    );
  });


  useEffect(() => {
    const handleResize =
      () => {
        setIsMobile(
          window.innerWidth <
            768
        );
      };


    window.addEventListener(
      "resize",
      handleResize
    );


    handleResize();


    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);


  /* =====================================
      PAGINATION
  ====================================== */

  const [
    page,
    setPage,
  ] = useState(0);


  const [
    limit,
  ] = useState(15);


  const totalPages =
    pagination?.totalPages ||
    0;


  /* =====================================
      SORT
  ====================================== */

  const [
    sortOrder,
    setSortOrder,
  ] = useState("");


  /* =====================================
      CATEGORY DATA
  ====================================== */

  const categoryTitle =
    isRTL
      ? category?.titleAr
      : category?.titleEn;


  const categoryDescription =
    isRTL
      ? category?.textAr
      : category?.textEn;


  /* =====================================
      FETCH MEALS
  ====================================== */

  useEffect(() => {
    if (!categoryId) {
      return;
    }


    dispatch(
      getAllMeals(
        page,
        limit,
        categoryId,
        undefined,
        undefined,
        sortOrder
      )
    );

  }, [
    page,
    limit,
    categoryId,
    sortOrder,
    dispatch,
  ]);


  /* =====================================
      SORT HANDLER
  ====================================== */

  const handleSortChange =
    (event) => {

      setSortOrder(
        event.target.value
      );

      setPage(0);
    };


  /* =====================================
      MOBILE CARD MODE
  ====================================== */

  /*
   * compact=true فقط:
   *
   * 1- الهاتف
   * 2- المستخدم اختار عمودين
   *
   * الكمبيوتر دائماً compact=false
   * حتى لا يتغير التصميم.
   */

  const compactCard =
    isMobile &&
    mobileMealColumns ===
      "two";


  /* =====================================
      CATEGORY FALLBACK
  ====================================== */

  if (!category) {
    return (
      <div
        className="
          min-h-screen

          flex
          items-center
          justify-center

          bg-back-primery
          dark:bg-back-darkprimery
        "
      >
        <Loader />
      </div>
    );
  }


  return (
    <>
      {/* =====================================
          HEADER
      ====================================== */}

      <Header
        active={4}
        DropActive={1}
      />


      <main
        className="
          min-h-screen

          bg-back-primery
          dark:bg-back-darkprimery
        "
      >

        {/* =================================
            HERO
        ================================= */}

        <section
          className="
            relative

            overflow-hidden

            h-[520px]
            md:h-[590px]
            lg:h-[640px]

            bg-color-2
          "
        >

          {/* Background Image */}

          <motion.img
            initial={{
              opacity: 0,
              scale: 1.08,
            }}

            animate={{
              opacity: 1,
              scale: 1,
            }}

            transition={{
              duration: 1.1,
            }}

            src={`${media}${category?.Image}`}

            alt={
              categoryTitle ||
              ""
            }

            className="
              absolute
              inset-0

              w-full
              h-full

              object-cover
            "
          />


          {/* Main Overlay */}

          <div
            className="
              absolute
              inset-0

              bg-black/15
            "
          />


          {/* Directional Overlay */}

          <div
            className={`
              absolute
              inset-0

              ${
                isRTL
                  ? `
                    bg-gradient-to-l

                    from-color-2/90
                    via-color-2/55
                    to-transparent
                  `
                  : `
                    bg-gradient-to-r

                    from-color-2/90
                    via-color-2/55
                    to-transparent
                  `
              }
            `}
          />


          {/* Bottom Overlay */}

          <div
            className="
              absolute
              inset-0

              bg-gradient-to-t

              from-color-2/80
              via-transparent
              to-black/10
            "
          />


          {/* Gold Glow */}

          <div
            className={`
              absolute

              top-20

              w-[300px]
              h-[300px]

              rounded-full

              bg-color-1/20

              blur-[120px]

              pointer-events-none

              ${
                isRTL
                  ? "-right-32"
                  : "-left-32"
              }
            `}
          />


          {/* Hero Content */}

          <div
            className="
              relative
              z-10

              container

              h-full

              flex
              items-end

              pb-14
              md:pb-20
            "
          >

            <motion.div
              initial={{
                opacity: 0,
                y: 45,
              }}

              animate={{
                opacity: 1,
                y: 0,
              }}

              transition={{
                duration: 0.75,
                delay: 0.15,
              }}

              className="
                max-w-[760px]
              "
            >

              {/* Small Label */}

              <div
                className="
                  flex
                  items-center

                  gap-3

                  mb-6
                "
              >

                <span
                  className="
                    block

                    w-12
                    md:w-16

                    h-[2px]

                    bg-color-1
                  "
                />


                <div
                  className="
                    flex
                    items-center

                    gap-2

                    text-color-1
                  "
                >

                  <BiRestaurant
                    className="
                      text-lg
                    "
                  />


                  <span
                    className="
                      font-kufi

                      text-xs
                      md:text-sm
                    "
                  >
                    {t(
                      "Yaman menu category"
                    )}
                  </span>

                </div>

              </div>


              {/* Category Title */}

              <h1
                className="
                  font-kufi
                  font-bold

                  text-white

                  text-[2.7rem]
                  leading-[1.4]

                  md:text-6xl

                  lg:text-[4.4rem]
                  lg:leading-[1.3]

                  mb-6
                "
              >
                {categoryTitle}
              </h1>


              {/* Description */}

              {categoryDescription && (

                <p
                  className="
                    max-w-2xl

                    font-kufi

                    text-sm
                    md:text-lg

                    text-white/75

                    leading-8
                    md:leading-9
                  "
                >
                  {
                    categoryDescription
                  }
                </p>

              )}


              {/* Scroll Indicator */}

              <div
                className="
                  flex
                  items-center

                  gap-3

                  mt-8
                "
              >

                <div
                  className="
                    flex

                    w-9
                    h-9

                    items-center
                    justify-center

                    rounded-full

                    border
                    border-white/20

                    text-color-1
                  "
                >
                  <FiArrowDown />
                </div>


                <span
                  className="
                    font-kufi

                    text-xs

                    text-white/50
                  "
                >
                  {t(
                    "explore category dishes"
                  )}
                </span>

              </div>

            </motion.div>

          </div>


          {/* Bottom Accent */}

          <div
            className="
              absolute

              bottom-0
              start-0

              w-32
              md:w-52

              h-[3px]

              bg-color-1
            "
          />

        </section>


        {/* =================================
            MEALS CONTENT
        ================================= */}

        <section
          id="meals-section"

          className="
            relative

            overflow-hidden

            bg-back-secondary
            dark:bg-back-darkprimery

            py-14
            md:py-20
            lg:py-24
          "
        >

          {/* Decoration 1 */}

          <div
            className="
              absolute

              -top-40
              -end-40

              w-[400px]
              h-[400px]

              rounded-full

              bg-color-1/10

              blur-[120px]

              pointer-events-none
            "
          />


          {/* Decoration 2 */}

          <div
            className="
              absolute

              -bottom-40
              -start-40

              w-[380px]
              h-[380px]

              rounded-full

              border
              border-color-1/10

              pointer-events-none
            "
          />


          <div
            className="
              container

              relative
              z-10
            "
          >

            {/* =================================
                TOOLBAR
            ================================= */}

            <motion.div
              initial={{
                opacity: 0,
                y: 25,
              }}

              animate={{
                opacity: 1,
                y: 0,
              }}

              transition={{
                duration: 0.55,
              }}

              className="
                flex
                flex-col

                lg:flex-row
                lg:items-end
                lg:justify-between

                gap-6

                pb-7
                mb-9

                border-b
                border-color-2/10
                dark:border-white/10
              "
            >

              {/* =============================
                  RESULTS INFO
              ============================== */}

              <div
                className="
                  flex

                  items-center

                  gap-5
                "
              >

                {/* Count */}

                <div
                  className="
                    flex
                    items-center

                    gap-4
                  "
                >

                  <div
                    className="
                      flex

                      w-12
                      h-12

                      shrink-0

                      items-center
                      justify-center

                      rounded-2xl

                      bg-color-1/10

                      text-color-1
                    "
                  >
                    <BiRestaurant
                      className="
                        text-xl
                      "
                    />
                  </div>


                  <div>

                    <span
                      className="
                        block

                        font-kufi
                        text-xs

                        text-color-1

                        mb-1
                      "
                    >
                      {t(
                        "available dishes"
                      )}
                    </span>


                    <p
                      className="
                        font-kufi

                        text-sm

                        text-n-6
                        dark:text-tcolor-2
                      "
                    >

                      <strong
                        className="
                          text-tcolor-4
                          dark:text-white
                        "
                      >
                        {
                          Allmeals
                            ?.length ||
                          0
                        }
                      </strong>


                      {" "}

                      {t(
                        "items"
                      )}


                      {pagination
                        ?.totalItems >
                        0 && (

                        <>
                          {" "}

                          {t(
                            "from"
                          )}

                          {" "}

                          <strong
                            className="
                              text-color-1
                            "
                          >
                            {
                              pagination
                                .totalItems
                            }
                          </strong>
                        </>

                      )}

                    </p>

                  </div>

                </div>

              </div>


              {/* =============================
                  SORT
              ============================== */}

              <div
                className="
                  flex
                  flex-col

                  sm:flex-row
                  sm:items-center

                  gap-3
                "
              >

                <div
                  className="
                    flex
                    items-center

                    gap-2

                    text-color-1
                  "
                >
                  <FiSliders />


                  <span
                    className="
                      font-kufi
                      text-sm

                      text-tcolor-4
                      dark:text-tcolor-1
                    "
                  >
                    {t(
                      "sort by"
                    )}
                  </span>

                </div>


                <select
                  value={
                    sortOrder
                  }

                  onChange={
                    handleSortChange
                  }

                  className="
                    w-full

                    sm:min-w-[220px]

                    rounded-full

                    border
                    border-color-2/10

                    bg-back-primery
                    dark:bg-back-darksecondary

                    px-5
                    py-3

                    font-kufi
                    text-sm

                    text-tcolor-4
                    dark:text-white

                    outline-none

                    transition-all
                    duration-300

                    focus:border-color-1

                    focus:ring-2
                    focus:ring-color-1/10
                  "
                >

                  <option
                    value=""
                  >
                    {t(
                      "default"
                    )}
                  </option>


                  <option
                    value="asc"
                  >
                    {t(
                      "price low high"
                    )}
                  </option>


                  <option
                    value="desc"
                  >
                    {t(
                      "price high low"
                    )}
                  </option>

                </select>

              </div>

            </motion.div>


            {/* =================================
                MEALS
            ================================= */}

            {isLoading ? (

              <div
                className="
                  min-h-[350px]

                  flex
                  items-center
                  justify-center
                "
              >
                <Loader />
              </div>

            ) : (

              <>

                {Allmeals?.length >
                0 ? (

                  <AnimatePresence
                    mode="wait"
                  >

                    <motion.div
                      key={`${mobileMealColumns}-${sortOrder}`}

                      initial={{
                        opacity: 0,
                      }}

                      animate={{
                        opacity: 1,
                      }}

                      exit={{
                        opacity: 0,
                      }}

                      transition={{
                        duration: 0.3,
                      }}

                      className={`
                        grid

                        ${
                          mobileMealColumns ===
                          "two"
                            ? `
                              grid-cols-2
                              gap-3
                            `
                            : `
                              grid-cols-1
                              gap-6
                            `
                        }

                        md:grid-cols-2
                        md:gap-7

                        xl:grid-cols-3
                        xl:gap-8
                      `}
                    >

                      {Allmeals.map(
                        (
                          meal,
                          index
                        ) => (

                          <motion.div
                            key={
                              meal._id
                            }

                            initial={{
                              opacity: 0,
                              y: 25,
                            }}

                            animate={{
                              opacity: 1,
                              y: 0,
                            }}

                            transition={{
                              duration: 0.45,

                              delay:
                                Math.min(
                                  index *
                                    0.04,
                                  0.25
                                ),
                            }}

                            className="
                              min-w-0
                            "
                          >

                            <MealsCard
                              meals={
                                meal
                              }

                              category={
                                category
                              }

                              compact={
                                compactCard
                              }
                            />

                          </motion.div>

                        )
                      )}

                    </motion.div>

                  </AnimatePresence>

                ) : (

                  /* =============================
                      EMPTY STATE
                  ============================== */

                  <motion.div
                    initial={{
                      opacity: 0,
                      y: 20,
                    }}

                    animate={{
                      opacity: 1,
                      y: 0,
                    }}

                    className="
                      rounded-[2rem]

                      border
                      border-color-1/15

                      bg-back-primery
                      dark:bg-back-darksecondary

                      py-16
                      px-6

                      text-center
                    "
                  >

                    <div
                      className="
                        flex

                        w-16
                        h-16

                        mx-auto
                        mb-5

                        items-center
                        justify-center

                        rounded-full

                        bg-color-1/10

                        text-color-1
                      "
                    >
                      <BiRestaurant
                        className="
                          text-3xl
                        "
                      />
                    </div>


                    <h2
                      className="
                        font-kufi
                        font-semibold

                        text-xl
                        md:text-2xl

                        text-tcolor-4
                        dark:text-tcolor-1

                        mb-3
                      "
                    >
                      {t(
                        "no dishes in this category"
                      )}
                    </h2>


                    <p
                      className="
                        max-w-lg

                        mx-auto

                        font-kufi
                        text-sm

                        text-n-6
                        dark:text-tcolor-2

                        leading-7
                      "
                    >
                      {t(
                        "new dishes will be added to this category"
                      )}
                    </p>

                  </motion.div>

                )}


                {/* =================================
                    PAGINATION
                ================================= */}

                {totalPages >
                  1 && (

                  <motion.div
                    initial={{
                      opacity: 0,
                      y: 20,
                    }}

                    whileInView={{
                      opacity: 1,
                      y: 0,
                    }}

                    viewport={{
                      once: true,
                    }}

                    className="
                      mt-14
                      md:mt-20
                    "
                  >

                    <Pagination
                      currentPage={
                        page
                      }

                      totalPages={
                        totalPages
                      }

                      setPage={
                        setPage
                      }
                    />

                  </motion.div>

                )}

              </>

            )}

          </div>

        </section>

      </main>


      <Fotter />
    </>
  );
}


export default AllMeals;